import React from "react";

const SalaryBreakdown = ({ earnings = [], deductions = [], variableComponents = [] }) => {
  const calculateTotal = (components) => {
    return components.reduce((sum, comp) => sum + (parseFloat(comp.amount) || 0), 0);
  };

  const totalEarnings = calculateTotal(earnings);
  const totalDeductions = calculateTotal(deductions);
  const netSalary = totalEarnings - totalDeductions;

  return (
    <div className="space-y-6 font-poppins">
      {/* Earnings Section */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Earnings
        </h3>
        <div className="space-y-2">
          {earnings.length > 0 ? (
            earnings.map((earning, index) => (
              <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200 dark:border-gray-700 last:border-0">
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {earning.name}
                  </span>
                  {earning.is_taxable !== undefined && (
                    <span className="text-xs text-gray-500 dark:text-gray-400">
                      {earning.is_taxable ? "Taxable" : "Non-taxable"}
                    </span>
                  )}
                </div>
                <span className="text-sm font-semibold text-green-600 dark:text-green-400">
                  ₹{parseFloat(earning.amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400">No earnings components</p>
          )}
        </div>
        <div className="mt-4 pt-4 border-t-2 border-gray-300 dark:border-gray-600 flex justify-between items-center">
          <span className="text-base font-bold text-gray-900 dark:text-white">
            Total Earnings
          </span>
          <span className="text-base font-bold text-green-600 dark:text-green-400">
            ₹{totalEarnings.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>

      {/* Deductions Section */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Deductions
        </h3>
        <div className="space-y-2">
          {deductions.length > 0 ? (
            deductions.map((deduction, index) => (
              <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200 dark:border-gray-700 last:border-0">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {deduction.name}
                </span>
                <span className="text-sm font-semibold text-red-600 dark:text-red-400">
                  -₹{parseFloat(deduction.amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400">No deduction components</p>
          )}
        </div>
        <div className="mt-4 pt-4 border-t-2 border-gray-300 dark:border-gray-600 flex justify-between items-center">
          <span className="text-base font-bold text-gray-900 dark:text-white">
            Total Deductions
          </span>
          <span className="text-base font-bold text-red-600 dark:text-red-400">
            -₹{totalDeductions.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>

      {/* Variable Components Section */}
      {variableComponents.length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Variable Components
          </h3>
          <div className="space-y-2">
            {variableComponents.map((component, index) => (
              <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200 dark:border-gray-700 last:border-0">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {component.name}
                </span>
                <span className="text-sm font-semibold text-blue-600 dark:text-blue-400">
                  ₹{parseFloat(component.amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Net Salary */}
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center">
          <span className="text-lg font-bold text-white">
            Net Salary
          </span>
          <span className="text-2xl font-bold text-white">
            ₹{netSalary.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SalaryBreakdown;

